import { CRMContactAPIPathGenerator, ContactDocument, FilterQuery, APIQueryParamFragments, APIResponse } from "server-model";
import { CRMContactConnector } from "../data-connectors";
import { AppServerConnector } from "./app-server.connector";

export class AppServerCRMContactConnector extends AppServerConnector implements CRMContactConnector {
    async getContact(organisationId: string, contactId: string, uniqueFieldName: string): Promise<APIResponse> {
        try {
            const response = await this.axios.get(
                CRMContactAPIPathGenerator.details(contactId),
                { ...this.getHeaders(), params: { [APIQueryParamFragments.FIELD_NAME]: uniqueFieldName } },
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Contact not found")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async listContacts(organisationId: string, userId: string, filterQuery: FilterQuery, isArchived: boolean = false): Promise<APIResponse> {
        try {
            const response = await this.axios.post(
                CRMContactAPIPathGenerator.list(),
                { filterQuery: this.toPlain(filterQuery) },
                { ...this.getHeaders(), params: { [APIQueryParamFragments.IS_ARCHIVED]: isArchived } },
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Contacts not found")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async createContact(contactDocument: ContactDocument): Promise<APIResponse> {
        try {
            const response = await this.axios.post(
                CRMContactAPIPathGenerator.create(),
                { contactDocument: this.toPlain(contactDocument) },
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to create contact")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async updateContact(organisationId: string, userId: string, contactId: string, contactDocument: Partial<ContactDocument>, uniqueFieldName: string): Promise<APIResponse> {
        try {
            const response = await this.axios.patch(
                CRMContactAPIPathGenerator.update(contactId),
                { contactDocument: this.toPlain(contactDocument) },
                { ...this.getHeaders(), params: { [APIQueryParamFragments.FIELD_NAME]: uniqueFieldName } },
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to update contact")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
    async deleteContact(organisationId: string, contactId: string): Promise<APIResponse> {
        try {
            const response = await this.axios.delete(
                CRMContactAPIPathGenerator.delete(contactId),
                this.getHeaders()
            )
            if (response && response.status === 200) {
                return response.data
            } else {
                throw new Error("Unable to delete contact")
            }
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
}